module.exports = require('ipfs-only-hash')
